export const accidentReportsAndMovingViolations = () => {
  return [
    { text: `     16. ACCIDENT REPORTS AND MOVING VIOLATIONS`, bold: true, style: 'p' },

    { text: ` Independent Contractor hereby agrees to immediately report to Company any motor vehicle accidents or moving violations involving Independent Contractor or any of Independent Contractor’s employees or subcontractors performing services hereunder.`, style: 'p' },
  ]
}